import { motion } from "framer-motion";
import { X } from "lucide-react";

export function ModalShell({ title, onClose, children }: { title: string; onClose: () => void; children: React.ReactNode }) {
  return (
    <motion.div
      initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
    >
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />
      <motion.div
        initial={{ opacity: 0, y: 20, scale: 0.97 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: 10, scale: 0.97 }}
        transition={{ duration: 0.25 }}
        className="relative z-10 w-full max-w-lg rounded-3xl bg-brand-text border border-brand-bg/[0.1] shadow-xl shadow-brand-bg/[0.08] p-7"
      >
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-lg font-bold text-brand-bg">{title}</h3>
          <button
            onClick={onClose}
            className="p-1.5 rounded-full bg-brand-bg/[0.05] hover:bg-brand-bg/[0.1] text-brand-bg/40 hover:text-brand-bg transition-colors"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
        {children}
      </motion.div>
    </motion.div>
  );
}
